module.exports = __webpack_public_path__ + "img/使用文档.8117b437.svg";